import { createAction } from 'redux-actions';
export const SET_ORDER = 'SET_ORDER';
export const FILL_ORDER = 'FILL_ORDER';
export const SET_LAST_REFUND = 'SET_LAST_REFUND';
export const SET_LAST_EXCHANGE = 'SET_LAST_EXCHANGE';
export const CLEAR_LAST_EXCHANGE = 'CLEAR_LAST_EXCHANGE';
export const ANALYZE_PURCHASEd_PRODUCTS = 'ANALYZE_PURCHASEd_PRODUCTS';
export const setOrder = createAction(SET_ORDER);
export const fillOrder = createAction(FILL_ORDER);
export const setLastRefund = createAction(SET_LAST_REFUND);
export const setLastExchange = createAction(SET_LAST_EXCHANGE);
export const clearLastExchange = createAction(CLEAR_LAST_EXCHANGE);
export const analyzePurchasedProducts = createAction(ANALYZE_PURCHASEd_PRODUCTS);
